module.exports = __webpack_public_path__ + "img/Frame People Smartphone.295d07e1.webp";